/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import {
  Button,
  Form,
  Modal,
  notification,
  Select,
  Tooltip,
  Typography,
  Upload,
  Row,
  Col,
  Spin,
} from 'antd';
import {
  CloudUploadOutlined,
  PlusOutlined,
  EyeOutlined,
  MoreOutlined,
  UploadOutlined,
} from '@ant-design/icons';
import EquipmentTypes from '../../components/admin/EquipmentTypes';
import AddNewEquipmentType from '../../components/admin/AddNewEquipmentType';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { fetchAdminPihEquipTypes } from '../../redux/admin/equipmentTypes/action';
import { uploadEquipmentfile } from '../../redux/admin/upload/action';
import { getExportDataListFromDatabase } from '../../redux/admin/equipmentTypes/saga';
import {
  downloadExcelFile,
  downloadTemplateFile,
  fetchMaintenanceTypes,
} from '../../redux/admin/maintenance/saga';
import { copyChecks } from '../../redux/admin/upload/action';

const { Text, Title } = Typography;
const { Option } = Select;

const Admin = (props) => {
  const {
    adminEquipTypesLoading,
    adminEquipTypes,
    onGetPihEquipmentTypes,
    onUploadEquipmentFiles,
    isUploadLoading,
    isChecksCopying,
    onCopyChecks,
  } = props;

  // Maitencance types
  const [checkOpen, setChecksOpen] = useState(false);
  const [openPage, setOpenPage] = useState('');

  //equipment Types
  const [equipTypeForm] = Form.useForm();
  const [equipTypeSearchForm] = Form.useForm();

  const [openModal, setOpenModel] = useState(false);
  const [equipTypeList, setEquipTypeList] = useState([]);
  const [equipTypeListDrop, setEquipTypeListDrop] = useState([]);
  const [clear, setClear] = useState(false);
  const [paginationClear, setPaginationClear] = useState(false);
  const [equipmentType, setEquipmentType] = useState('');
  const [editModelValue, setEditModelValue] = useState('');
  const [editRecord, setEditRecord] = useState('');

  const [fileList, setFileList] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [openUploadModal, setOpenUploadModal] = useState(false);
  const [disableFileUpload, setDisableFileUpload] = useState(false);
  const [searchCriteria, setSearchCriteria] = useState('');
  const [EquipmentDataList, setEquipmentDataList] = useState([]);
  const [searchType, setSearchType] = useState(null);
  const [searchFilterType, setSearchFilterType] = useState('');
  const [isDownloading, setIsDownloading] = useState(false);
  const [isTemplateDownloading, setIsTemplateDownloading] = useState(false);
  const [openCopyChecksModal, setOpenCopyChecksModal] = useState(false);
  const [form] = Form.useForm();
  const [fromEquipment, setFromEquipment] = useState('');

  // Add state for maintenance type dropdown
  const [maintenanceTypeList, setMaintenanceTypeList] = useState([]);
  const [maintenanceTypeLoading, setMaintenanceTypeLoading] = useState(false);

  /** Getting Equipment Types data on load */
  // useEffect(() => {
  //     onGetPihEquipmentTypes({
  //         pageSize: 20,
  //         pageNumber: 1
  //     });
  // }, []);

  useEffect(() => {
    (async () => {
      const list = await getExportDataListFromDatabase();

      if (list && list.rows.length > 0) setEquipmentDataList(list.rows);
      // const dashBoardList = await GetDashboardList();
      // if (dashBoardList)
      //     setDashboardList(dashBoardList)
      //console.log('DashBoard List', dashBoardList)
    })();
  }, []);

  /** Setting the equipment type values to the state */
  useEffect(() => {
    console.log('adminEquipTypes>>', adminEquipTypes);
    setEquipTypeList(adminEquipTypes);
    setEquipTypeListDrop(adminEquipTypes);
  }, [adminEquipTypes]);

  /** Setting Create new Equipment Model Open */
  const handleCreateEquip = () => {
    setOpenModel(true);
    setEditModelValue(false);
    setEditRecord('');
  };

  /** Getting Searched values from the selected equipment type */
  const onSearchEquipmentType = () => {
    equipTypeSearchForm.validateFields().then(async (data) => {
      if (data && data.equipmentType) {
        setClear(true);
        const newArray = adminEquipTypes.find((u) => u.pihEquipmentType === data.equipmentType);
        setEquipTypeList([newArray]);
        setPaginationClear(true);
      } else {
        notification.warning({
          message: 'Select Equipment Type to Search.',
        });
      }
    });
  };

  /** View clera button on select of equipment type */
  const onSelectEquipType = () => {
    setClear(true);
  };

  /** clearing selected data from equipment type dropdown */
  const OnclearEquipType = () => {
    setClear(false);
    setSearchCriteria('');
    setSearchFilterType('');
    setSearchType(null);
    equipTypeSearchForm.resetFields();
    // setEquipTypeList(adminEquipTypes)
    setPaginationClear(false);
    // onGetPihEquipmentTypes({
    //     pageSize: 10,
    //     pageNumber: 1
    // });
    // setEquipTypeListDrop(adminEquipTypes);
  };

  /** Setting Properties for upload file  */
  const fileProps = {
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
      setDisableFileUpload(false);
    },
    beforeUpload: (file) => {
      //for multiple upload
      // setFileList([...fileList, file]);
      // if (fileList.length > 0) {
      //     notification.warn({ message: 'Upload only one file at a time.' })
      // } else {
      // for single file upload
      setFileList([file]);
      setDisableFileUpload(true);
      // }
      return false;
    },
    fileList,
  };

  /** Fucntion to call upload file api and get **presigned Url to upload file to aws s3 bucket */
  const handleUploadFile = async () => {
    if (fileList.length > 0) {
      await onUploadEquipmentFiles(fileList);
    } else {
      notification.warn({ message: 'Please select a file to upload.' });
    }
  };

  /** Removing file and closing upload window on cancel */
  const handleCancelUploadFile = () => {
    setFileList([]);
    setUploading(false);
    setOpenUploadModal(false);
    setDisableFileUpload(false);
  };

  useEffect(() => {
    if (!isUploadLoading) {
      setFileList([]);
      setUploading(false);
      setOpenUploadModal(false);
      setDisableFileUpload(false);
    }
  }, [isUploadLoading]);

  const onSearch = (value) => {
    onGetPihEquipmentTypes({ searchKey: value });
  };

  const handleDownloadClick = async () => {
    if (isDownloading) return;

    setIsDownloading(true);
    try {
      await downloadExcelFile();
    } catch (error) {
      console.error('Download failed:', error);
    } finally {
      setIsDownloading(false);
    }
  };

  const handleTemplateDownloadClick = async () => {
    if (isTemplateDownloading) return;

    setIsTemplateDownloading(true);
    try {
      await downloadTemplateFile();
    } catch (error) {
      console.error('Template download failed:', error);
    } finally {
      setIsTemplateDownloading(false);
    }
  };

  const handleSearchInputChange = (value) => {
    console.log('handleSearchInputChange', value, searchFilterType.length);
    //  if (value != '')
    setSearchFilterType(value);
    if (searchFilterType.length == 1 || value != '') setSearchCriteria(value);
    // else
    //     setSearchCriteria('');
  };

  const handleComboboxChange = async (value) => {
    console.log('handleComboboxChange', value);
    setSearchType(value);
    if (value) setSearchCriteria(value);
    else setSearchCriteria('');
  };
  const handleSearchBlur = () => {
    const isValid = EquipmentDataList.some(
      (item) => item.pihEquipmentType?.toLowerCase() === searchCriteria?.toLowerCase()
    );
    if (!isValid) {
      console.log('handleSearchBlur', isValid);
      setSearchCriteria('');
      setSearchType(undefined);
    }
  };
  const tagRender = (props) => {
    return null;
  };

  /** Handle cancel for copy checks modal */
  const handleCancel = () => {
    setOpenCopyChecksModal(false);
    form.resetFields();
    setFromEquipment('');
  };

  const handleCopyChecks = async () => {
    try {
      const values = await form.validateFields();
      console.log('Form values:', values);

      // Ensure maintenanceTypes is an array
      const maintenanceTypeIds = Array.isArray(values.maintenanceTypes)
        ? values.maintenanceTypes
        : [];

      const payload = {
        fromEquipment: values.fromEquipment,
        toEquipment: values.toEquipment,
        maintenanceTypeIds: maintenanceTypeIds,
      };

      console.log('Sending payload:', payload);
      await onCopyChecks(payload);

      setOpenCopyChecksModal(false);
      form.resetFields();
      setFromEquipment('');
    } catch (error) {
      console.error('Error copying checks:', error);
      notification.error({
        message: 'Copy Failed',
        description: 'Failed to copy checks. Please try again.',
      });
    }
  };

  // Function to fetch maintenance types
  const fetchMaintenanceTypeList = async () => {
    try {
      setMaintenanceTypeLoading(true);
      const maintenanceTypes = await fetchMaintenanceTypes();
      setMaintenanceTypeList(maintenanceTypes);
    } catch (error) {
      console.error('Error fetching maintenance types:', error);
      notification.error({
        message: 'Failed to load maintenance types',
        description: 'Please try again later.',
      });
      // Set empty array on error
      setMaintenanceTypeList([]);
    } finally {
      setMaintenanceTypeLoading(false);
    }
  };

  // Fetch maintenance types when component mounts
  useEffect(() => {
    fetchMaintenanceTypeList();
  }, []);

  return (
    <div className="d-flex flex-column h-100 admin">
      {!checkOpen && (
        <>
          <div className="d-flex mt-0.5 justify-content-between  tab-content-title">
            <div className="d-flex align-items-center">
              <Title
                className="mb-0"
                level={4}
              >
                List of Equipments
              </Title>
            </div>

            <div>
              <div className="text-right new-calibration new-project-team">
                <Text
                  onClick={handleCreateEquip}
                  className="ps-3 add-new-team"
                >
                  <span className="icon-22">
                    <svg>
                      <use xlinkHref="#add" />
                    </svg>
                  </span>
                  Create New Equipment Type
                </Text>

                <Text
                  onClick={handleDownloadClick}
                  className={`ps-3 add-new-team ${isDownloading ? 'disabled' : ''}`}
                  style={{ cursor: isDownloading ? 'not-allowed' : 'pointer' }}
                >
                  <span className="icon-22">
                    {isDownloading ? (
                      <svg
                        className="animate-spin"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"></path>
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M12 3v18M5 12l7 7 7-7"></path>
                      </svg>
                    )}
                  </span>
                  {isDownloading ? 'Downloading...' : 'Download Database'}
                </Text>

                <Text
                  onClick={handleTemplateDownloadClick}
                  className={`ps-3 add-new-team ${isTemplateDownloading ? 'disabled' : ''}`}
                  style={{ cursor: isTemplateDownloading ? 'not-allowed' : 'pointer' }}
                >
                  <span className="icon-22">
                    {isTemplateDownloading ? (
                      <svg
                        className="animate-spin"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"></path>
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M12 3v18M5 12l7 7 7-7"></path>
                      </svg>
                    )}
                  </span>
                  {isTemplateDownloading ? 'Downloading...' : 'Download Template'}
                </Text>

                <Text
                  onClick={() => {
                    setOpenUploadModal(true);
                  }}
                  className="ps-3 add-new-team"
                >
                  <span className="icon-22">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      transform="rotate(180)"
                    >
                      <path d="M12 3v18M5 12l7 7 7-7"></path>
                    </svg>
                  </span>
                  Upload File
                </Text>

                <Text
                  onClick={() => {
                    setOpenCopyChecksModal(true);
                  }}
                  className="ps-3 add-new-team"
                >
                  <span className="icon-22">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="1em"
                      height="1em"
                      viewBox="0 0 1024 1024"
                    >
                      <path
                        fill="currentColor"
                        d="M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32M704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32M382 896h-.2L232 746.2v-.2h150z"
                      />
                    </svg>
                  </span>
                  Copy Checks
                </Text>
              </div>
            </div>
          </div>
          <div className="custom-line" />
        </>
      )}
      <div>
        <EquipmentTypes
          checkOpen={checkOpen}
          setChecksOpen={setChecksOpen}
          equipTypeList={equipTypeList}
          setEquipTypeList={setEquipTypeList}
          adminEquipTypesLoading={adminEquipTypesLoading}
          setOpenModel={setOpenModel}
          openModal={openModal}
          equipTypeForm={equipTypeForm}
          equipmentType={equipmentType}
          setEquipmentType={setEquipmentType}
          editModelValue={editModelValue}
          setEditModelValue={setEditModelValue}
          setEditRecord={setEditRecord}
          editRecord={editRecord}
          openPage={openPage}
          setOpenPage={setOpenPage}
          equipTypeSearchForm={equipTypeSearchForm}
          OnclearEquipType={OnclearEquipType}
          clear={clear}
          setClear={setClear}
          paginationClear={paginationClear}
          setPaginationClear={setPaginationClear}
          searchCriteria={searchCriteria}
          setSearchCriteria={setSearchCriteria}
        />
      </div>

      {/* Modal to create/update equipmentType */}
      <AddNewEquipmentType
        setOpenModel={setOpenModel}
        openModal={openModal}
        equipTypeForm={equipTypeForm}
        equipmentType={equipmentType}
        setEquipmentType={setEquipmentType}
        editModelValue={editModelValue}
        setEditModelValue={setEditModelValue}
        setEditRecord={setEditRecord}
        editRecord={editRecord}
      />

      <Modal
        className="pipeline-modal"
        title="Upload Equipment Data"
        centered
        visible={openUploadModal}
        footer={[
          <Button
            key="cancel"
            onClick={handleCancelUploadFile}
          >
            {'Cancel'}
          </Button>,
          <Button
            key="apply"
            type="primary"
            onClick={handleUploadFile}
            loading={isUploadLoading}
          >
            {isUploadLoading ? 'uploading' : 'Upload'}
          </Button>,
        ]}
      >
        <div className="uploadFile_admin">
          <Upload
            {...fileProps}
            maxCount={1}
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          >
            <Button
              disabled={disableFileUpload}
              icon={<CloudUploadOutlined className="icon-22" />}
            >
              Select File
            </Button>
          </Upload>
          <Text
            type="secondary"
            style={{ display: 'block', marginTop: '8px' }}
          >
            Note: Each equipment check must be unique based on equipment type, maintenance type,
            interval, and identifier. Uploading a duplicate will update the existing record instead
            of creating a new one.
          </Text>
        </div>
      </Modal>

      <Modal
        width="45vw"
        className="pipeline-modal"
        title="Copy Checks"
        centered
        visible={openCopyChecksModal}
        footer={[
          <Button
            key="cancel"
            onClick={handleCancel}
          >
            Cancel
          </Button>,
          <Button
            key="apply"
            type="primary"
            onClick={handleCopyChecks}
            loading={isChecksCopying}
          >
            Copy
          </Button>,
        ]}
      >
        {isChecksCopying ? (
          <Spin tip="Loading...">
            <div style={{ minHeight: '200px' }} />
            Loading...
          </Spin>
        ) : (
          <Form
            form={form}
            name="basic"
            layout="vertical"
            autoComplete="off"
          >
            <Row gutter={16}>
              <Col lg={12}>
                <Form.Item label="From Equipment" name="fromEquipment" required>
                  <Select
                    className="client-select"
                    showSearch
                    optionFilterProp="children"
                    placeholder="Select Equipment"
                    onChange={(value) => setFromEquipment(value)}
                    value={fromEquipment}
                    allowClear
                    style={{ borderRadius: "5px" }}
                  >
                    {equipTypeListDrop &&
                      equipTypeListDrop.map((item, i) => (
                        <Option key={i} value={item && item.id}>
                          {item && item.pihEquipmentType}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col lg={12}>
                <Form.Item label="To Equipment" name="toEquipment" required>
                  <Select
                    className="client-select"
                    showSearch
                    optionFilterProp="children"
                    placeholder="Select Equipment"
                    allowClear
                    size="middle"
                  >
                    {equipTypeListDrop &&
                      equipTypeListDrop
                        .filter((x) => x.id !== fromEquipment)
                        .map((item, i) => (
                          <Option key={i} value={item && item.id}>
                            {item && item.pihEquipmentType}
                          </Option>
                        ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col lg={12}>
                <Form.Item
                  name="maintenanceTypes"
                  label="Maintenance Types"
                  required
                  rules={[
                    {
                      required: true,
                      message: "Please select at least one maintenance type",
                    },
                  ]}
                >
                  <Select
                    className="maintenance-select"
                    showSearch
                    optionFilterProp="children"
                    placeholder="Select Maintenance Types"
                    mode="multiple"
                    style={{
                      width: "100%",
                    }}
                    allowClear
                    getPopupContainer={() => document.body}
                  >
                    {Array.isArray(maintenanceTypeList) &&
                      maintenanceTypeList.map((type, index) => (
                        <Select.Option key={index} value={type.id}>
                          {type.name}
                        </Select.Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        )}
        <p style={{ fontSize: '14px', color: 'orangered' }}>
          *Note: Please note that Source Equipment data will replace existing data in Destination
          Equipment.
        </p>
      </Modal>
    </div>
  );
};

const mapStateToProps = ({ adminEquipTypeReducer, uploadReducer, maintenanceReducer }) => {
  const adminEquipTypes = get(adminEquipTypeReducer, 'adminEquipTypes', []);
  const adminEquipTypesLoading = get(adminEquipTypeReducer, 'adminEquipTypesLoading', false);
  const isUploadLoading = get(uploadReducer, 'isUploadLoading', false);
  const isChecksCopying = get(uploadReducer, 'isChecksCopying', false);
  const maintenanceTypes = get(maintenanceReducer, 'maintenanceTypes', []);
  return {
    adminEquipTypes,
    adminEquipTypesLoading,
    isUploadLoading,
    isChecksCopying,
    maintenanceTypes,
  };
};

const mapDispatchToProps = {
  onGetPihEquipmentTypes: fetchAdminPihEquipTypes,
  onUploadEquipmentFiles: uploadEquipmentfile,
  onCopyChecks: copyChecks,
  onFetchMaintenanceTypes: fetchMaintenanceTypes,
};

export default connect(mapStateToProps, mapDispatchToProps)(Admin);